class DlXcottonPpM extends HTMLElement {
  constructor() {
    super();
    this.container = null;
    this.items = [];
    this.currentVariantId = null;
  }

  connectedCallback() {
    this.container = this.querySelector('.dl-xcotton-pp-m-container');
    if (!this.container) return;

    this.init();
  }

  init() {
    // 获取所有保护项
    this.items = Array.from(this.querySelectorAll('.dl-xcotton-pp-m-content-item'));
    this.productH = this.closest('dl-product-h');
    // 获取当前显示的变体ID
    const currentItem = this.querySelector('.dl-xcotton-pp-m-content-item.dl-show');
    if (currentItem) {
      this.currentVariantId = currentItem.dataset.dlVariantId;
    }

    // 绑定点击事件
    this.bindEvents();

    // 监听产品变体切换事件
    this.listenToVariantChange();
  }

  bindEvents() {
    this.items.forEach(item => {
      item.addEventListener('click', (e) => {
        this.handleItemClick(item);
      });
    });
  }

  handleItemClick(clickedItem) {
    const variantId = clickedItem.dataset.dlVariantId;
    
    // 移除同一变体下所有项的选中状态
    this.items.forEach(item => {
      if (item.dataset.dlVariantId === variantId) {
        item.classList.remove('dl-selected');
      }
    });

    // 添加选中状态到点击的项
    clickedItem.classList.add('dl-selected');
    this.productH.setTotal();
    // 触发自定义事件，通知外部选择已改变
    this.dispatchEvent(new CustomEvent('xcotton:change', {
      bubbles: true,
      detail: this.getSelectedInfo()
    }));
  }

  // 监听产品变体切换
  listenToVariantChange() {
    document.addEventListener('variant:change', (e) => {
      if (e.detail && e.detail.variant && e.detail.variant.id) {
        this.switchVariant(e.detail.variant.id);
      }
    });
  }

  // 切换显示的变体保护选项
  switchVariant(variantId) {
    this.currentVariantId = variantId;
    
    this.items.forEach(item => {
      const itemVariantId = item.dataset.dlVariantId;
      
      if (itemVariantId == variantId) {
        item.classList.add('dl-show');
        // 移除当前变体下所有项的选中状态，准备重置为 no-thanks
        item.classList.remove('dl-selected');
      } else {
        item.classList.remove('dl-show');
      }
    });

    // 每次切换变体时，默认选中 no-thanks
    const noThanksItem = this.items.find(item => 
      item.dataset.dlVariantId == variantId && 
      item.dataset.dlType === 'no-thanks'
    );
    if (noThanksItem) {
      noThanksItem.classList.add('dl-selected');
    }

    // 更新总价
    if (this.productH && this.productH.setTotal) {
      this.productH.setTotal();
    }

    // 变体切换后，触发选择变化事件
    this.dispatchEvent(new CustomEvent('xcotton:change', {
      bubbles: true,
      detail: this.getSelectedInfo()
    }));
  }

  // 静态方法：供外部调用，切换延保服务显示
  static toggle(variantId) {
    const xcottonElements = document.querySelectorAll('dl-xcotton-pp-m');
    xcottonElements.forEach(element => {
      if (element.switchVariant) {
        element.switchVariant(variantId);
      }
    });
  }

  // 公共方法：获取当前选中的保护信息
  getSelectedInfo() {
    const variantId = this.currentVariantId;
    if (!variantId) {
      return null;
    }

    // 查找当前变体下选中的项
    const selectedItem = this.items.find(item => 
      item.dataset.dlVariantId == variantId && 
      item.classList.contains('dl-selected')
    );

    if (!selectedItem) {
      return null;
    }

    const type = (selectedItem.dataset.dlType || '').trim();
    
    if (type === 'no-thanks') {
      return {
        type: 'no-thanks',
        variantId: variantId,
        xcottonVariantId: null,
        xcottonPrice: 0,
        xcottonProperty: null
      };
    }

    const price = parseFloat(selectedItem.dataset.dlXcottonVariantPrice) || 0;
    return {
      type: 'xcotton',
      variantId: variantId,
      xcottonVariantId: selectedItem.dataset.dlXcottonVariantId,
      xcottonPrice: price,
      xcottonProperty: selectedItem.dataset.dlXcottonProperty,
      variantTitle: selectedItem.dataset.dlVariantTitle,
      variantSku: selectedItem.dataset.dlVariantSku
    };
  }

  // 公共方法：获取当前选中的保护价格
  getSelectedPrice() {
    const info = this.getSelectedInfo();
    const price = info ? info.xcottonPrice : 0;
    return price;
  }

  // 公共方法：获取当前选中的保护变体ID
  getSelectedVariantId() {
    const info = this.getSelectedInfo();
    return info ? info.xcottonVariantId : null;
  }

  // 公共方法：获取当前选中的保护属性（用于添加到购物车的properties）
  getSelectedProperty() {
    const info = this.getSelectedInfo();
    return info ? info.xcottonProperty : null;
  }

  // 公共方法：检查是否选择了保护计划
  hasProtection() {
    const info = this.getSelectedInfo();
    return info && info.type === 'xcotton';
  }

  // 公共方法：重置选择
  reset() {
    this.items.forEach(item => {
      item.classList.remove('dl-selected');
      
      // 默认选中 no-thanks 项
      if (item.dataset.dlType === 'no-thanks') {
        item.classList.add('dl-selected');
      }
    });

    this.dispatchEvent(new CustomEvent('xcotton:change', {
      bubbles: true,
      detail: this.getSelectedInfo()
    }));
  }
}

customElements.define('dl-xcotton-pp-m', DlXcottonPpM);